import React from 'react';
import { CommandeDefWithEleve } from '../../../types/commande/commande.def';
import { FeatureContainer } from '../../molecules/Containers/FeatureContainer';
import ClientDetail from '../../../views/CommandeSingle/ClientDetail';
import LivraisonDetail from '../../../views/CommandeSingle/LivraisonDetail';
import ProduitDetail from '../../../views/CommandeSingle/ProduitDetail';
import HeaderSingleProduct from '../../../views/CommandeSingle/Header';
import { ContainerTwoThirds } from '../../layouts/ContainerTwoThirds';
import emojis from '../../../theme/emoji';
import { Divider } from 'components/atoms/Dividers/Divider';
import { HeaderText } from '../../atoms/Texts/HeaderText';

interface RecapCommandeProps {
  commande: CommandeDefWithEleve;
}

const RecapCommande = ({ commande }: RecapCommandeProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <ContainerTwoThirds
        col1={
          <>
            <FeatureContainer padding="small">
              <HeaderText
                text="Informations de facturation"
                emoji={emojis['Crayon']}
                fontsize="small"
              />
            </FeatureContainer>
            <Divider isBottomMenu={true} />
            <ClientDetail client={commande.client} variant="recapCommande" />
          </>
        }
        col2={
          <>
            <FeatureContainer padding="small">
              <HeaderText
                text="Informations commande"
                emoji={emojis['Package']}
                fontsize="small"
              />
            </FeatureContainer>
            <Divider isBottomMenu={true} />
            <HeaderSingleProduct variant="recapCommande" commande={commande} />
          </>
        }
      />
      <FeatureContainer padding="small">
        <HeaderText
          text="Informations de livraison"
          emoji={emojis['PostBox']}
          fontsize="small"
        />
        <Divider margin={false} />
        <LivraisonDetail client={commande.client} />
      </FeatureContainer>
      <FeatureContainer padding="small">
        <HeaderText
          text="Liste des produits commandés"
          emoji={emojis['ShoppingBags']}
          fontsize="small"
        />
      </FeatureContainer>
      {commande.commandelines && commande.commandelines.length > 0 ? (
        <ProduitDetail commandelines={commande.commandelines} />
      ) : (
        <p>Commande vide.</p>
      )}
    </div>
  );
};
export default RecapCommande;
